var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('WrapperPreviewCategory',{attrs:{"customClass":"section-preview_lk"}},[_vm._v(" Кабинет администратора ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }